import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Crud, CrudService } from '../../../core';
import { ClienteGrupo } from '../cliente-grupo';

@Injectable({
    providedIn: 'root'
})
export class ClienteGrupoCrudHttpService implements Crud<ClienteGrupo> {
    resource = 'clientegrupo';

    constructor(private crudService: CrudService) { }

    /** Pesquisa todos os clientes grupos cadastrados */
    search(): Observable<ClienteGrupo[]> {
        return this.crudService.search<ClienteGrupo>(this.resource);
    }

    /** Procura um único cliente grupo através do seu ID */
    find(id: number): Observable<ClienteGrupo> {
        return this.crudService.find<ClienteGrupo>(this.resource, id);
    }

    /** Carrega um único cliente grupo através do seu ID */
    load(id: number): Observable<ClienteGrupo> {
        return this.crudService.load<ClienteGrupo>(this.resource, id);
    }

    /** Insere um novo cliente grupo */
    insert(entity: ClienteGrupo): Observable<ClienteGrupo> {
        return this.crudService.insert<ClienteGrupo>(this.resource, entity);
    }

    /** Altera um cliente grupo existente */
    update(entity: ClienteGrupo): Observable<ClienteGrupo> {
        return this.crudService.update<ClienteGrupo>(this.resource, entity);
    }

    /** Exclui um cliente grupo através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
